import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface CategoryObject {
  id: number;
  name: Array<any>;
}

export interface CategoryListInfo {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  categories: Array<CategoryObject>;
  errors: unknown;
}

@Module
export default class CategoriesModule
  extends VuexModule
  implements CategoryListInfo
{
  categories = [] as Array<CategoryObject>;
  page = 1;
  take = 10;
  itemCount = 0;
  pageCount = 1;
  hasPreviousPage = false;
  hasNextPage = true;
  errors = {};

  /**
   * Get categories list
   * @returns Array<CategoryObject>
   */
  get categoriesList(): Array<CategoryObject> {
    return this.categories;
  }

  /**
   * Get total items
   * @returns number
   */
  get categoriesListCount(): number {
    return this.itemCount;
  }

  @Mutation
  [Mutations.SET_CATEGORIES](data) {
    this.categories = data.data;
    this.page = data.meta.page;
    this.take = data.meta.take;
    this.itemCount = data.meta.itemCount;
    this.pageCount = data.meta.pageCount;
    this.hasPreviousPage = data.meta.hasPreviousPage;
    this.hasNextPage = data.meta.hasNextPage;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_CATEGORIES_CURRENT_PAGE](page) {
    this.page = page;
  }

  @Mutation
  [Mutations.RESET_CATEGORIES_LIST]() {
    this.categories = [] as Array<CategoryObject>;
    this.page = 1;
    this.take = 10;
    this.itemCount = 0;
    this.pageCount = 1;
    this.hasPreviousPage = false;
    this.hasNextPage = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_CATEGORIES_STORE]() {
    this.context.commit(Mutations.RESET_CATEGORIES_LIST);
  }

  @Action
  [Actions.CREATE_CATEGORY](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/category', data)
      .then(() => {
        this.context.commit(Mutations.RESET_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.DELETE_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/category', id)
      .then(() => {
        this.context.commit(Mutations.RESET_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_CATEGORY]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/category', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_CATEGORIES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_CATEGORY_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_CATEGORIES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_CATEGORY](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/category', id);
  }

  @Action
  [Actions.GET_CATEGORIES]() {
    const params = {
      page: this.page,
    };
    ApiService.setAuthorizationHeader();
    return ApiService.query('/category', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_CATEGORIES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.statusText],
        // });
      });
  }
}
